import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import Spinner from "components/base/Spinner";
import { Alert } from "components/base/Toast";
import { FaExternalLinkAlt, FaSyncAlt } from "react-icons/fa";
import { BsStarFill } from "react-icons/bs";
import ImagesPreview from "components/shared/ImagesPreview";
import useUploadProtection from "hooks/useUploadProtection";
import {
  SET_PRODUCT_LINE_IMAGE_PRIMARY,
  SYNC_PRODUCT_LINE_IMAGES,
} from "./graphql";

const ProductLineView = ({ productLine, stage }) => {
  const images = productLine.newImages.filter((i) => i.stage === stage);

  const [setPrimary, setPrimaryRes] = useMutation(
    SET_PRODUCT_LINE_IMAGE_PRIMARY,
    {
      onCompleted() {
        Alert("success", "New Primary Image Set.");
      },
      onError(error) {
        Alert("error", parseError(error));
      },
    },
  );

  const [syncImages, syncImagesRes] = useMutation(SYNC_PRODUCT_LINE_IMAGES, {
    variables: { slug: productLine.slug },
    onCompleted() {
      Alert("success", "Images Synced.");
    },
    onError(error) {
      Alert("error", parseError(error));
    },
  });

  useUploadProtection(
    syncImagesRes.loading,
    "Image sync is in progress. Leaving the page may cancel the sync. Continue?",
  );

  return (
    <div className="border-b dark:border-gray-700 pb-4">
      <h4 className="p-6">{productLine.name}</h4>

      {images.length > 0 ? (
        <div className="flex ml-6 mr-2 relative overflow-auto">
          {images.map((i, index) => (
            <div
              key={i.id}
              className="relative"
              onDoubleClick={() =>
                setPrimary({
                  variables: {
                    productLineId: productLine.id,
                    productLineImageId: i.id,
                    stage,
                  },
                })
              }
            >
              {i.isPrimary ? (
                <div className="absolute text-yellow-500 text-2xl top-2 left-2">
                  <BsStarFill />
                </div>
              ) : null}
              <div className="w-36 mr-4 mb-4">
                <img src={i.thumb} alt={i.name} />

                <div className="break-all w-full text-xs text-center mt-2">
                  {i.name}
                </div>
              </div>
            </div>
          ))}

          {setPrimaryRes.loading ? <Spinner text="Processing..." /> : null}
        </div>
      ) : (
        <div className="px-6 opacity-70">No beautyshot for this item yet.</div>
      )}

      <div className="p-6 pb-0 flex space-x-6">
        <div className="opacity-70">
          Folder name should be:{" "}
          <span className=" font-bold">{productLine.slug}</span>
        </div>
        <Button
          onClick={() => {
            window.open(
              `https://wabobaadmin.sharepoint.com/sites/Waboba/Shared%20Documents/wis/beautyshots/${stage}/${productLine.slug}`,
              "_blank",
            );
          }}
          icon={<FaExternalLinkAlt />}
        >
          Open
        </Button>

        <Button
          onClick={() => {
            if (
              window.confirm(
                "Are you sure to sync images from SharePoint to WIS?",
              )
            ) {
              syncImages();
            }
          }}
          loading={syncImagesRes.loading}
          icon={<FaSyncAlt />}
        >
          Sync
        </Button>
      </div>
    </div>
  );
};

export default ProductLineView;
